export default "__VITE_ASSET__DrGeiHE___"